import { render, staticRenderFns } from "./EventIndex.vue?vue&type=template&id=9d408bdc&scoped=true&"
import script from "./EventIndex.vue?vue&type=script&lang=js&"
export * from "./EventIndex.vue?vue&type=script&lang=js&"
import style0 from "./EventIndex.vue?vue&type=style&index=0&id=9d408bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d408bdc",
  null
  
)

export default component.exports